import { render, staticRenderFns } from "./ReviewMenu.vue?vue&type=template&id=0183e196"
import script from "./ReviewMenu.vue?vue&type=script&lang=js"
export * from "./ReviewMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports